<template>
  <div class="buy-view">
    <site-menu theme="dark" class="menu"/>
    <div class="inner">
      <iframe
        class="iframe"
        src="https://wannago.show/www/wa/event?id=4&k=odb6kv1zi6z8fa2397cy68b6b345zz&e=WNGEvent"
      />
    </div>
  </div>
</template>

<script>
  import SiteMenu from '@/components/SiteMenu.vue'

  export default {
    name: 'buy-view',
    components: { SiteMenu },
    data() {
      return {
      }
    },
    methods: {
    },
  }
</script>
<style scoped lang="scss">
  .buy-view {
    position: relative;
  }
  .iframe {
    width: 100%;
    height: 800px;
    margin-top: 4px;
    border: 0;    
  }
  @media (max-width: 500px) {
    .iframe {
      margin-top: 40px;
    }
  }
</style>